import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
    Edit_Item_List_Item_PUT,
    Get_Item_List_Item_GET,
    Save_Item_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import ModalWrapper from "components/common/ModalWrapper";
import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Select from "react-select";
import { MODAL_LOADER } from "utils/constants";
import { isEmpty } from "utils/TextUtils";
import MultiImageSelector from "./MultiImageSelector";
import ImageSelector from "components/common/ImageSelector";
import VideoSelector from "components/common/VideoSelector";
import { ChevronDown, ChevronUp, Edit } from "utils/SvgComponent";

const ItemAddEdit = ({
    show,
    hideModal,
    recordID,
    handleRefresh,
    cuisineKeyPairList,
    indregientKeyPairList,
    condimentsKeyPairList,
    itemKeyPairList,
    customizationKeyPairList,
}) => {
    const defaultRowsObj = {
        ingredientUuid: "",
        unitOfMeasurement: "",
        quantity: 0,
        tag: ""
    };

    const condimentObj = {
        condimentId: 0,
        title: "",
        recipeReferenceId: ""
    };

    const customizationObj = {
        itemCustomizationId: "",
        customizationOptionList: [
            // {
            //     id: 0,
            //     name: "",
            //     recipeReferenceId: ""
            // }
        ]
    };

    const defaultRecordObj = {
        cuisineUuid: "",
        title: "",
        description: "",
        itemVideoRefId: "",
        itemPlatewareImageRefId: "",
        itemDisposableImageRefId: "",
        itemImageRefIds: [],
        itemIngredients: [],
        cookingProcedures: [],
        accompaniments: [],
        garnishes: [],
        shelfLife: [],
        warning: [],
        condiment: null,
    };
    const [record, setRecord] = useState(defaultRecordObj);
    const [itemImageRefIds, setItemImageRefIds] = useState([]);
    const [rows, setRows] = useState([]);
    const [inputCookingStep, setInputCookingStep] = useState(null);
    const [cookingProcedureSteps, setCookingProcedureSteps] = useState([]);
    const [inputAccompaniments, setInputAccompaniments] = useState("");
    const [accompaniments, setAccompaniments] = useState([]);
    const [inputGarnishes, setInputGarnishes] = useState("");
    const [inputShelfLife, setInputShelfLife] = useState("");
    const [inputWarning, setInputWarning] = useState(null);
    const [garnishes, setGarnishes] = useState([]);
    const [shelfLife, setShelfLife] = useState([]);
    const [warning, setWarning] = useState([]);
    const [condimentList, setCondimentList] = useState([condimentObj]);
    const [customizationList, setCustomizationList] = useState([customizationObj]);


    useEffect(() => {
        if (recordID) {
            callGetApi(
                MODAL_LOADER,
                Get_Item_List_Item_GET.replace("{uuid}", recordID),
                {},
                (response) => {
                    if (response.errorCode === API_SUCCESS) {
                        const res = response.responsePacket;
                        const _cuisineUuid = cuisineKeyPairList.find(
                            (obj) => obj.key === res.cuisineUuid
                        );

                        setRecord({
                            ...res,
                            cuisineUuid: _cuisineUuid || "",
                        });

                        // const _rows = [];
                        const _itemImageRefIds = res.itemImageRefIds;
                        const _ingredientDtoList = res.ingredientDetailList;
                        const _rows = _ingredientDtoList.map((item, i) => {
                            const hello = indregientKeyPairList?.find((guide) => guide.value === item.ingredientUuid)
                            const unitObj = hello?.tag?.find((unit) => unit.value === item.unitOfMeasurement);
                            return {
                                ingredientUuid: hello,
                                unitOfMeasurement: unitObj,
                                quantity: item.quantity,
                                tag: hello?.tag,
                                id: i + 1
                            }
                        })
                        const _condiment = res?.condimentsDetailList?.map((item) => ({
                            condimentId: item?.condimentId || "",
                            title: item?.title || "",
                            recipeReferenceId: item?.recipeReferenceId || ""
                        }))
                        if (_condiment?.length) {
                            setCondimentList(_condiment)
                        } else {
                            setCondimentList([])
                        }
                        const _customization = Array.isArray(res?.customizationDetailList) ? res?.customizationDetailList.map((item) => ({
                            itemCustomizationId: item?.itemCustomizationId || "",
                            customizationOptionList: Array.isArray(item.customizationOptionList) ? item.customizationOptionList.map((item) => ({
                                id: item?.id || "",
                                name: item.name || "",
                                recipeReferenceId: item.recipeReferenceId || ""
                            })) : []
                        })) : []
                        setCustomizationList(_customization)



                        let getImgIdRef = [];
                        _itemImageRefIds.map((data) => {
                            getImgIdRef.push({ id: data, path: data });
                        });

                        setRows(_rows);

                        setItemImageRefIds(res.itemImageRefIds);
                        const convertToEditable = (list = []) =>
                            list.map((item) => ({ value: item, editFlag: false }));

                        setCookingProcedureSteps(convertToEditable(res?.cookingProcedures));
                        setAccompaniments(convertToEditable(res?.accompaniments));
                        setGarnishes(convertToEditable(res?.garnishes));
                        setShelfLife(convertToEditable(res?.shelfLife));
                        setWarning(convertToEditable(res?.warning));
                        setItemImageRefIds([...getImgIdRef]);
                    }
                }
            );
        }
    }, [recordID]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRecord({ ...record, [name]: value });
    };

    const handleSelectChange = (e) => {
        setRecord((pre) => ({ ...pre, cuisineUuid: e }));
    };

    const handleDeleteRow = (i) => {
        const _rows = [...rows];
        _rows.splice(i, 1); // 2nd parameter means remove one item only
        setRows(_rows);
    };

    const handleAddRowEvent = () => {
        const _rows = [...rows];
        _rows.push({
            ...defaultRowsObj,
            id: _rows.length + 1,
        });
        setRows(_rows);
    };

    const handleTextChange = (e, i) => {
        const { name, type, value } = e.target;
        const _rows = [...rows];
        let _selectedRow = { ..._rows[i] };
        if (type === "number") {
            _selectedRow = { ..._rows[i], [name]: parseFloat(value) };
        } else {
            _selectedRow = { ..._rows[i], [name]: value };
        }
        _rows.splice(i, 1, _selectedRow);
        setRows(_rows);
    };

    const handleRowSelectChange = (e, key, i) => {
        const _rows = [...rows];

        const _selectedRow = { ..._rows[i], [key]: e, "tag": e?.tag, "unitOfMeasurement": e?.tag?.find((item) => item.key === "openUnit") };

        _rows.splice(i, 1, _selectedRow);
        setRows(_rows);
    };

    const handleRowMeasurementSelectChange = (e, key, i) => {
        const _rows = [...rows];

        const _selectedRow = { ..._rows[i], [key]: e };

        _rows.splice(i, 1, _selectedRow);
        setRows(_rows);
    };

    const handleEditListInput = (e, i, setter) => {
        setter(prev => {
            const updated = prev.map((item, index) =>
                index === i ? { ...item, value: e.target.value } : item
            );
            return updated;
        });
    };

    // handle edit flag
    const toggleEditFlag = (i, setter) => {
        setter(prev =>
            prev.map((item, index) => ({
                ...item,
                editFlag: index === i ? !item.editFlag : false
            }))
        );
    };

    // handle move steps
    const moveListItem = (i, setter, direction) => {
        setter(prev => {
            const updated = [...prev];
            if (direction === "UP" && i > 0) {
                [updated[i - 1], updated[i]] = [updated[i], updated[i - 1]];
            } else if (direction === "DOWN" && i < updated.length - 1) {
                [updated[i], updated[i + 1]] = [updated[i + 1], updated[i]];
            }
            return updated;
        });
    };

    // handle remove steps
    const removeListItem = (i, setter) => {
        setter(prev => prev.filter((_, index) => index !== i));
    };

    const handleAddList = (inputValue, setInput, setter) => {
        if (isEmpty(inputValue) || inputValue.trim() === "") {
            toast.error("Enter procedure step", { id: "toast-error" });
            return;
        };
        setter(prev => [...prev, { value: inputValue, editFlag: false }]);
        setInput("")
    };

    const handleMultiImage = (e) => {
        const id = new Date().getTime();
        const newItem = { id: id, path: "" };
        setItemImageRefIds([...itemImageRefIds, newItem]);
    };

    const handleImageSelect = (refId, id) => {
        let _itemImageRefIds = [...itemImageRefIds];
        for (let i = 0; i < _itemImageRefIds.length; i++) {
            let image = _itemImageRefIds[i];
            if (image.id === id) {
                image.path = refId;
                break;
            }
        }
        setItemImageRefIds([..._itemImageRefIds]);
    };

    const handleRemoveItemImage = (id) => {
        const _itemImageRefIds = itemImageRefIds.filter(
            (data) => data.id !== id
        );
        setItemImageRefIds([..._itemImageRefIds]);
    };

    const viewItemImages = useCallback(() => {
        return (
            <>
                {itemImageRefIds.map((image, i) => (
                    <MultiImageSelector
                        key={image.id}
                        id={image.id}
                        selectedImage={image.path}
                        handleRemoveImage={handleRemoveItemImage}
                        handleImageSelect={handleImageSelect}
                    />
                ))}
            </>
        );
    }, [itemImageRefIds.length]);

    // add condiment
    const addCondimentRow = () => {
        setCondimentList([...condimentList, condimentObj]);
    };

    //remove condiment
    const removeCondimentRow = (i) => {
        const updatedList = condimentList.filter((_, index) => index !== i);
        setCondimentList(updatedList);
    };

    // handle condiment
    const handleCondimentChange = (selectedOption, i) => {
        const updatedList = [...condimentList];
        if (selectedOption) {
            const matchedItem = findItem(selectedOption.key);
            updatedList[i] = {
                condimentId: selectedOption?.value || "",
                title: selectedOption?.label || "",
                recipeReferenceId: matchedItem?.key || "",
            }
        } else {
            updatedList[i] = {
                condimentId: "",
                title: "",
                recipeReferenceId: "",
            }
        }
        setCondimentList(updatedList)
    };
    // find first Item
    const findItem = (id) => {
        let item = itemKeyPairList.find((item) => item.value === id)
        return item;
    };

    // handle customization
    const handleCustomizationChange = (selectedOption, index) => {
        let updatedList = [...customizationList];
        const recipeReferenceIds = selectedOption?.key?.map(item => item.recipeReferenceId) || [];
        findItemsByIds(recipeReferenceIds)

        updatedList[index] = {
            ...updatedList[index],
            itemCustomizationId: selectedOption?.value || "",
            customizationOptionList: selectedOption?.key,
        }
        setCustomizationList(updatedList)
    };
    const findItemsByIds = (id) => {
        let items = itemKeyPairList.filter((item) => id.includes(item.value))
        return items;
    }

    // add customization
    const addCustomizationRow = () => {
        setCustomizationList([...customizationList, customizationObj]);
    };

    //remove customization
    const removeCustomizationRow = (i) => {
        const updatedList = customizationList.filter((_, index) => index !== i);
        setCustomizationList(updatedList);
    };




    const checkInputValidation = () => {
        if (isEmpty(record.cuisineUuid)) {
            toast.error("Cuisine must not be empty.", {
                id: "record.cuisineUuid",
            });
            return;
        } else if (isEmpty(record.title)) {
            toast.error("Title must not be empty.", {
                id: "title",
            });
            return;
        }
        //  else if (isEmpty(record.description)) {
        //     toast.error("Description must not be empty.", {
        //         id: "addressLine",
        //     });
        //     return;
        // }
        // else if (itemImageRefIds.length <= 0) {
        //     toast.error("Image must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // } 
        else if (rows.length <= 0) {
            toast.error(
                "Add Ingredient, Unit Of Measurement,Quantity must not be empty.",
                {
                    id: "itemImageRefIds",
                }
            );
            return;
        }
        // else if (cookingProcedureSteps.length <= 0) {
        //     toast.error("Cooking Procedure must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // } 
        // else if (accompaniments.length <= 0) {
        //     toast.error("Accompaniments must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // } 
        // else if (garnishes.length <= 0) {
        //     toast.error("Garnishes must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // } 
        // else if (shelfLife.length <= 0) {
        //     toast.error("Shelf Life must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // } 
        // else if (warning.length <= 0) {
        //     toast.error("Warning must not be empty.", {
        //         id: "itemImageRefIds",
        //     });
        //     return;
        // }
        // for (let i = 0; i < itemImageRefIds.length; i++) {
        //     if (isEmpty(itemImageRefIds[i])) {
        //         toast.error(`Multi Image must not be empty.`, {
        //             id: "MultiImage",
        //         });
        //         return;
        //     }
        // }

        for (let i = 0; i < rows.length; i++) {
            // if (isEmpty(rows[i].brandUuid)) {
            //     toast.error(`Brand Name must not be empty.`, {
            //         id: "BrandName",
            //     });
            //     return;
            // } else
            if (isEmpty(rows[i].ingredientUuid)) {
                toast.error(`Ingredient must not be empty.`, {
                    id: "ingredientUuid",
                });
                return;
            } else if (isEmpty(rows[i].unitOfMeasurement)) {
                toast.error(`Unit Of Measurement must not be empty.`, {
                    id: "unitOfMeasurement",
                });
                return;
            } else if (isEmpty(rows[i].quantity)) {
                toast.error(`Quantity must not be empty.`, {
                    id: "quantity",
                });
                return;
            }
        }
        return true;
    };

    const handleSubmit = () => {
        try {
            const _itemImageRefIds = itemImageRefIds.map((data) => data.path);
            if (!checkInputValidation()) {
                return;
            }
            const _rows = [];
            const rowsLength = rows.length;
            for (let i = 0; i < rowsLength; i++) {
                _rows.push({
                    // brandUuid: rows[i].brandUuid?.key || "",
                    ingredientUuid: rows[i].ingredientUuid?.value || "",
                    ingredientName: rows[i].ingredientUuid?.label || "",
                    unitOfMeasurement: rows[i].unitOfMeasurement?.value || "",
                    quantity: rows[i].quantity || 0,
                });
            }
            if (!checkInputValidation()) {
                return;
            };

            const extractValues = (arr) => Array.isArray(arr) ? arr.map(item => item.value) : [];


            const recordObj = {
                ...record,
                cuisineUuid: record.cuisineUuid?.key || "",
                itemImageRefIds: _itemImageRefIds,
                itemIngredients: _rows,
                cookingProcedures: extractValues(cookingProcedureSteps),
                accompaniments: extractValues(accompaniments),
                garnishes: extractValues(garnishes),
                shelfLife: extractValues(shelfLife),
                warning: extractValues(warning),
                condimentsDetailList: condimentList,
                customizationDetailList: customizationList,
                recipeType: "ITEM_RECIPE",

            };
            if (recordID) {
                // update
                callPutApi(
                    MODAL_LOADER,
                    Edit_Item_List_Item_PUT.replace("{uuid}", recordID),
                    recordObj,
                    {},
                    (res) => {
                        if (res.errorCode === API_SUCCESS) {
                            hideModal(false);
                            handleRefresh();
                        }
                    }
                );
            } else {
                // Create
                callPostApi(
                    MODAL_LOADER,
                    Save_Item_List_Item_POST,
                    recordObj,
                    {},
                    (res) => {
                        if (res.errorCode === API_SUCCESS) {
                            hideModal(false);
                            handleRefresh();
                        }
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            }
        } catch (error) {
            return;
        }
    };
    const handleVideoChange = (videoRefId) => {
        setRecord({ ...record, itemVideoRefId: videoRefId });
    };

    const handlePlatewareChange = (imageName) => {
        setRecord({ ...record, itemPlatewareImageRefId: imageName });
    };
    const handleDisposableChange = (imageName) => {
        setRecord({ ...record, itemDisposableImageRefId: imageName });
    };


    return (
        <>
            <ModalWrapper
                show={show}
                hide={hideModal}
                header={`${recordID ? "Update" : "Add"}`}
                handleSubmit={handleSubmit}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="" className="form-label">
                                Cuisine
                            </label>
                            <Select
                                value={record?.cuisineUuid}
                                onChange={handleSelectChange}
                                options={cuisineKeyPairList}
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label htmlFor="" className="form-label">
                                Title
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={record?.title}
                                name="title"
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label htmlFor="" className="form-label">
                                Description
                            </label>
                            <textarea
                                type="text"
                                className="form-control"
                                value={record?.description}
                                name="description"
                                onChange={(e) => handleInputChange(e)}
                            ></textarea>
                        </div>
                        <div className="col-lg-12 my-2">
                            { }
                            <VideoSelector
                                handleVideoChange={handleVideoChange}
                                selectedVideo={record.itemVideoRefId}
                                mediaType="VIDEO"
                            />
                        </div>
                        <div className="col-lg-12 my-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label htmlFor="" className="form-label">
                                        Plateware
                                    </label>
                                    <div className="restaurant-images p-2 card border mb-0">
                                        <ImageSelector
                                            style={{
                                                width: "100%",
                                                height: "130px",
                                                overflow: "hidden",
                                                cursor: "pointer",
                                            }}
                                            user={true}
                                            handleImageChange={
                                                handlePlatewareChange
                                            }
                                            selectedImage={
                                                record.itemPlatewareImageRefId
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label htmlFor="" className="form-label">
                                        Disposable
                                    </label>
                                    <div className="restaurant-images p-2 card border mb-0">
                                        <ImageSelector
                                            style={{
                                                width: "100%",
                                                height: "130px",
                                                overflow: "hidden",
                                                cursor: "pointer",
                                            }}
                                            user={true}
                                            handleImageChange={
                                                handleDisposableChange
                                            }
                                            selectedImage={
                                                record.itemDisposableImageRefId
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 my-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) => handleMultiImage(e)}
                            >
                                Add Image
                            </button>
                            <div
                                className="restaurant-images p-2 card border mb-0 mt-2 align-content-center  justify-content-center "
                                style={{ height: "185px" }}
                            >
                                <div className="w-100">
                                    <div
                                        className="text-center"
                                        style={{ opacity: "0.4" }}
                                    >
                                        {itemImageRefIds.length > 0
                                            ? ""
                                            : "Add images"}
                                    </div>
                                    <div className="d-flex overflow-auto">
                                        {viewItemImages()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 my-2">
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={(e) => handleAddRowEvent(e)}
                                >
                                    Add Row
                                </button>
                            </div>
                            <div className="restaurant-images p-2 card border mb-0 mt-2">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            {/* <th scope="col">Brand</th> */}
                                            <th scope="col">Ingredient</th>
                                            <th scope="col">
                                                Unit Of Measurement
                                            </th>
                                            <th scope="col">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.length !== 0 &&
                                            rows.map((row, i) => (
                                                <tr key={i}>
                                                    {/* <td>
                                                        <Select
                                                            value={
                                                                row?.brandUuid
                                                            }
                                                            onChange={(e) =>
                                                                handleRowSelectChange(
                                                                    e,
                                                                    "brandUuid",
                                                                    i
                                                                )
                                                            }
                                                            options={
                                                                brandKeyPairList
                                                            }
                                                        />
                                                    </td> */}
                                                    <td>
                                                        <Select
                                                            value={row?.ingredientUuid}
                                                            onChange={(e) => handleRowSelectChange(e, "ingredientUuid", i)}
                                                            options={indregientKeyPairList}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select
                                                            value={row?.unitOfMeasurement}
                                                            onChange={(e) => handleRowMeasurementSelectChange(e, "unitOfMeasurement", i)}
                                                            options={row?.tag}
                                                            isDisabled={!!row?.tag ? false : true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="quantity"
                                                            value={row?.quantity}
                                                            onChange={(e) => handleTextChange(e, i)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={(e) => handleDeleteRow(i)}
                                                        >X</button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-lg-12 my-2">
                            <h4>Cooking Procedure</h4>
                            <ul>
                                {cookingProcedureSteps.map((data, i) => (
                                    <li key={i}>
                                        <div className="d-flex justify-content-between align-items-center my-2">
                                            {!data.editFlag ? (
                                                <span>{data.value}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.value}
                                                    onChange={(e) => handleEditListInput(e, i, setCookingProcedureSteps)}
                                                />
                                            )}

                                            <div className="d-flex gap-2">
                                                <span className="btn btn-primary py-0 px-1" onClick={() => toggleEditFlag(i, setCookingProcedureSteps)}>
                                                    <Edit width="24" fill="white" />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setCookingProcedureSteps, "UP")}>
                                                    <ChevronUp />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setCookingProcedureSteps, "DOWN")}>
                                                    <ChevronDown />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => removeListItem(i, setCookingProcedureSteps)}>
                                                    X
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Write Cooking Procedure Step"
                                value={inputCookingStep}
                                onChange={(e) =>
                                    setInputCookingStep(e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleAddList(inputCookingStep, setInputCookingStep, setCookingProcedureSteps)}
                            >
                                Add Cooking Procedure Step
                            </button>
                        </div>
                        <div className="col-lg-12 my-2">
                            <h4>Accompaniments</h4>
                            <ul>
                                {accompaniments.map((data, i) => (
                                    <li key={i}>
                                        <div className="d-flex justify-content-between align-items-center my-2">
                                            {!data.editFlag ? (
                                                <span>{data.value}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.value}
                                                    onChange={(e) => handleEditListInput(e, i, setAccompaniments)}
                                                />
                                            )}

                                            <div className="d-flex gap-2">
                                                <span className="btn btn-primary py-0 px-1" onClick={() => toggleEditFlag(i, setAccompaniments)}>
                                                    <Edit width="24" fill="white" />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setAccompaniments, "UP")}>
                                                    <ChevronUp />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setAccompaniments, "DOWN")}>
                                                    <ChevronDown />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => removeListItem(i, setAccompaniments)}>
                                                    X
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>

                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Write Accompaniments"
                                value={inputAccompaniments}
                                onChange={(e) =>
                                    setInputAccompaniments(e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleAddList(inputAccompaniments, setInputAccompaniments, setAccompaniments)}
                            >
                                Add Accompaniments
                            </button>
                        </div>
                        <div className="col-lg-12 my-2">
                            <h4>Garnishes</h4>
                            <ul>
                                {garnishes.map((data, i) => (
                                    <li key={i}>
                                        <div className="d-flex justify-content-between align-items-center my-2">
                                            {!data.editFlag ? (
                                                <span>{data.value}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.value}
                                                    onChange={(e) => handleEditListInput(e, i, setGarnishes)}
                                                />
                                            )}

                                            <div className="d-flex gap-2">
                                                <span className="btn btn-primary py-0 px-1" onClick={() => toggleEditFlag(i, setGarnishes)}>
                                                    <Edit width="24" fill="white" />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setGarnishes, "UP")}>
                                                    <ChevronUp />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setGarnishes, "DOWN")}>
                                                    <ChevronDown />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => removeListItem(i, setGarnishes)}>
                                                    X
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Write Garnishes"
                                value={inputGarnishes}
                                onChange={(e) =>
                                    setInputGarnishes(e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleAddList(inputGarnishes, setInputGarnishes, setGarnishes)}
                            >
                                Add Garnishes
                            </button>
                        </div>
                        <div className="col-lg-12 my-2">
                            <h4>Shelf Life</h4>
                            <ul>
                                {shelfLife.map((data, i) => (
                                    <li key={i}>
                                        <div className="d-flex justify-content-between align-items-center my-2">
                                            {!data.editFlag ? (
                                                <span>{data.value}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.value}
                                                    onChange={(e) => handleEditListInput(e, i, setShelfLife)}
                                                />
                                            )}

                                            <div className="d-flex gap-2">
                                                <span className="btn btn-primary py-0 px-1" onClick={() => toggleEditFlag(i, setShelfLife)}>
                                                    <Edit width="24" fill="white" />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setShelfLife, "UP")}>
                                                    <ChevronUp />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setShelfLife, "DOWN")}>
                                                    <ChevronDown />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => removeListItem(i, setShelfLife)}>
                                                    X
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Write Shelf Life"
                                value={inputShelfLife}
                                onChange={(e) =>
                                    setInputShelfLife(e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleAddList(inputShelfLife, setInputShelfLife, setShelfLife)}
                            >
                                Add Shelf Life
                            </button>
                        </div>
                        <div className="col-lg-12 my-2">
                            <h4>Warning</h4>
                            <ul>
                                {warning.map((data, i) => (
                                    <li key={i}>
                                        <div className="d-flex justify-content-between align-items-center my-2">
                                            {!data.editFlag ? (
                                                <span>{data.value}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.value}
                                                    onChange={(e) => handleEditListInput(e, i, setWarning)}
                                                />
                                            )}

                                            <div className="d-flex gap-2">
                                                <span className="btn btn-primary py-0 px-1" onClick={() => toggleEditFlag(i, setWarning)}>
                                                    <Edit width="24" fill="white" />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setWarning, "UP")}>
                                                    <ChevronUp />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => moveListItem(i, setWarning, "DOWN")}>
                                                    <ChevronDown />
                                                </span>
                                                <span className="btn btn-primary py-0 px-1" onClick={() => removeListItem(i, setWarning)}>
                                                    X
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Write Warning"
                                value={inputWarning}
                                onChange={(e) =>
                                    setInputWarning(e.target.value)
                                }
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleAddList(inputWarning, setInputWarning, setWarning)}
                            >
                                Add Warning
                            </button>
                        </div>
                        {condimentList?.length > 0 && condimentList.map((data, i) => {
                            const condimentKey = data?.recipeReferenceId;
                            const itemTitle = condimentKey
                                ? itemKeyPairList.find((item) => item.value === condimentKey)
                                : null;
                            return (
                                <div className="row" key={i}>
                                    <div className=" col-lg-6">
                                        <label>Condiment</label>
                                        <Select
                                            isClearable
                                            options={condimentsKeyPairList}
                                            value={condimentsKeyPairList.find((item) => item.value === data?.condimentId) || null}
                                            onChange={(e) => handleCondimentChange(e, i)}
                                            menuPlacement="top"
                                        />


                                    </div>
                                    <div className=" col-lg-5">
                                        <label> Recipe Item</label>
                                        <input
                                            type="text"
                                            className="form-control input-default"
                                            value={itemTitle?.label || ""}
                                            readOnly={true}
                                        />
                                    </div>
                                    <div className="col-1" style={{ marginTop: "35px" }}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) => removeCondimentRow(i)}
                                        >X</button>
                                    </div>
                                </div>
                            )
                        })}

                        <div className="row mt-3 align-items-center justify-content-between">
                            <div className="col-auto">
                                <button className="btn mt-2 btn-primary"
                                    onClick={addCondimentRow}
                                >
                                    Add Condiment
                                </button>
                            </div>
                        </div>
                    </div>
                    {customizationList?.length > 0 && (
                        <div className="row mt-4">
                            {customizationList.map((custom, i) => (
                                <div className="col-md-12 mb-3" key={i}>
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label">Customization {i + 1}</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    onClick={(e) => removeCustomizationRow(i)}
                                                >
                                                    X
                                                </button>
                                            </div>

                                            <Select
                                                isClearable
                                                options={customizationKeyPairList}
                                                value={customizationKeyPairList.find((item) => item.value === custom.itemCustomizationId)}
                                                onChange={(e) => handleCustomizationChange(e, i)}
                                                menuPlacement="top"
                                                className="mb-3"
                                            />

                                            {custom?.customizationOptionList?.length > 0 && (
                                                <div className="mt-2">
                                                    <label className="form-label">Items</label>
                                                    <div style={{ maxHeight: '170px', overflowY: 'auto', border: '1px solid #ccc' }}>
                                                        <table className="table table-sm table-bordered mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Item</th>
                                                                    <th> Recipe Item</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {custom?.customizationOptionList?.map((item, index) => {
                                                                    const itemKey = item?.recipeReferenceId;
                                                                    const itemTitle = itemKey
                                                                        ? itemKeyPairList.find((item) => item.value === itemKey)
                                                                        : null;

                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{item?.id}</td>
                                                                            <td>{item?.name}</td>
                                                                            <td>{itemTitle?.label}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="row mt-3">
                        <div className="col-12">
                            <button
                                className="btn btn-primary"
                                onClick={addCustomizationRow}
                            >
                                Add Customization
                            </button>
                        </div>
                    </div>
                </div>
            </ModalWrapper >
        </>
    );
};

export default ItemAddEdit;
